export const HIDDEN_FIELDS = ['id', '_class', 'toolId', 'version', 'jobSetId'];
